import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle() {
    const html = document.documentElement
    const goingLight = !html.classList.contains("light")

    if (goingLight) {
      html.classList.add("light")
      localStorage.setItem("thingz-theme", "light")
    } else {
      html.classList.remove("light")
      localStorage.setItem("thingz-theme", "dark")
    }
  }
}
